module.exports = __webpack_public_path__ + "img/九芝堂-1.0be13ff7.png";